import React, { FC } from 'react';
import { AdfoxContextData, AdfoxContextProvider } from '../../context/AdfoxContext';
import { PParams } from '../../../types';
import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import styles from './AdfoxBannerMainPageArticleDesktop.css';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextData['postViewAnalyticsData'] = {
  place: 'article',
  place__DEPRECATED: 'journal',
  name__DEPRECATED: 'Journal_maipage_article',
};

const P_PARAMS: PParams = { p1: 'ddcgw', p2: 'fkhj' };

const SIZE: AdfoxContextData['size'] = { height: '400px', width: '100%' };

export const AdfoxBannerMainPageArticleDesktop: FC = () => {
  return (
    <AdfoxContextProvider
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      place="mainPageArticle"
      size={SIZE}
      pParams={P_PARAMS}
    >
      {() => <AdfoxBannerContainer wrapperClassName={styles['wrapper']} />}
    </AdfoxContextProvider>
  );
};
